import React from 'react';
import { useQuestPrize } from '../../../../../hooks/shared/quests/useQuestPrize';
import { isNumber } from 'lodash';
import classNames from 'classnames';
import { useAccountMode } from '../../../../../hooks/useAccountMode';
import CompletedCounter from '../completed-counter/CompletedCounter';

export default function ChallengeSectionReward({ challengeData }) {
  const { mode: accountMode } = useAccountMode();

  const { mainPrize, mainReward } = useQuestPrize(challengeData);

  return (
    <div className={'challenges__section-reward'}>
      <div className={'task__item-cost'}>
        <img className={'task__item-icon'} src={mainPrize?.image} />

        {isNumber(mainReward) && (
          <div className={classNames('task__item-value', `task__item-value_${accountMode}`)}>{`+${mainReward}`}</div>
        )}
      </div>
      <CompletedCounter challengeData={challengeData} />
    </div>
  );
}
